import { mainApi } from '../config/apiClient';

// ============================================
// TYPES
// ============================================
// Backend: Plan 1 KioskProductVisibilityController
// Wire response: { success: true, data: ["productId1", "productId2"] }
//
// SignalR payload (PascalCase, default JsonHubProtocol — Plan 1.5.1 onayli):
//   { KioskId: 1, FirebaseProductId: "abc", IsHidden: true }
// Bu yuzden POST body de PascalCase gonderilir (backend [Required] BindRequired ile bu key'leri bekler).

export interface SetVisibilityPayload {
  KioskId: number;
  FirebaseProductId: string;
  IsHidden: boolean;
}

// ============================================
// API METHODS
// ============================================

const BASE = '/api/KioskProductVisibility';

function unwrapList<T>(raw: any): T[] {
  if (Array.isArray(raw)) return raw as T[];
  if (raw && Array.isArray(raw.data)) return raw.data as T[];
  if (raw && Array.isArray(raw.Data)) return raw.Data as T[];
  return [];
}

export const kioskProductVisibilityApi = {
  /**
   * Bir kiosk icin gizli urun ID'lerini doner. Default davranis: kayit yoksa urun gorunurdur.
   * Sadece IsHidden=true ve IsDeleted=false olanlar listede yer alir.
   */
  async getHiddenForKiosk(kioskId: number): Promise<string[]> {
    if (!kioskId || kioskId <= 0) return [];
    const url = `${BASE}/hidden/${kioskId}`;
    console.log('🌐 [kioskProductVisibilityApi] getHiddenForKiosk GET:', url);
    try {
      const { data } = await mainApi.get(url);
      const list = unwrapList<string>(data);
      console.log('✅ [kioskProductVisibilityApi] getHiddenForKiosk yanıt:', {
        kioskId,
        rawData: data,
        listCount: list.length,
        ids: list,
      });
      return list;
    } catch (err: any) {
      console.error('❌ [kioskProductVisibilityApi] getHiddenForKiosk HATA:', {
        url,
        message: err?.message,
        status: err?.response?.status,
        responseData: err?.response?.data,
      });
      throw err;
    }
  },

  /**
   * Bir urunun bir kiosk'taki gorunurlugunu set eder (upsert / soft-delete).
   * Backend cagriyi `OnKioskProductVisibilityChanged` event'i ile hem
   * `Company_{companyId}` hem `Kiosk_{KioskId}` gruplarina yayinlar.
   */
  async setVisibility(payload: SetVisibilityPayload): Promise<void> {
    const url = `${BASE}/set`;
    // ⏱️ TEŞHİS: gecikme ölçümü için server'a bir client_ts gönderiyoruz —
    // server log'una bu damga düşerse upstream kim daha geç bilebiliriz.
    const clientSentAt = Date.now();
    const clientSentIso = new Date(clientSentAt).toISOString();
    console.log(
      `⏱️ [LATENCY-TRACE] WEB→API setVisibility START at ${clientSentIso} (epoch=${clientSentAt})`,
      payload,
    );
    try {
      const response = await mainApi.post(url, payload);
      const apiResponseAt = Date.now();
      console.log(
        `⏱️ [LATENCY-TRACE] WEB←API setVisibility DONE at ${new Date(apiResponseAt).toISOString()} ` +
          `(epoch=${apiResponseAt}, http_rtt=${apiResponseAt - clientSentAt}ms)`,
        { status: response.status, data: response.data },
      );
    } catch (err: any) {
      console.error('❌ [kioskProductVisibilityApi] setVisibility HATA:', {
        url,
        payload,
        message: err?.message,
        status: err?.response?.status,
        responseData: err?.response?.data,
      });
      throw err;
    }
  },
};

export default kioskProductVisibilityApi;
